import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ngSanitize from 'angular-sanitize'
import footerComponent from './footer.component';
import stCookieSettings from '../stCookieSettings/stCookieSettings';

const footerModule = angular.module('footer', [
    uiRouter,
    ngSanitize,
    stCookieSettings
  ])
  .component('footer', footerComponent)
  .name;

export default footerModule;



// WEBPACK FOOTER //
// ./client/app/common/footer/footer.js